var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"progress-step-bar"},[_c('ul',{staticClass:"steps"},_vm._l((_vm.length),function(i){return _c('li',{key:i,class:[i <= _vm.step ? _vm.activeClass : '']})}),0)])}
var staticRenderFns = []

export { render, staticRenderFns }